import wi_alien from './weather_icons/wi-alien.svg'
import wi_moon_waxing_gibbous_1 from './weather_icons/wi-moon-waxing-gibbous-1.svg'
import wi_barometer from './weather_icons/wi-barometer.svg'
import wi_moon_waxing_gibbous_2 from './weather_icons/wi-moon-waxing-gibbous-2.svg'
import wi_celsius from './weather_icons/wi-celsius.svg'
import wi_moon_waxing_gibbous_3 from './weather_icons/wi-moon-waxing-gibbous-3.svg'
import wi_cloud_down from './weather_icons/wi-cloud-down.svg'
import wi_moon_waxing_gibbous_4 from './weather_icons/wi-moon-waxing-gibbous-4.svg'
import wi_cloud_refresh from './weather_icons/wi-cloud-refresh.svg'
import wi_moon_waxing_gibbous_5 from './weather_icons/wi-moon-waxing-gibbous-5.svg'
import wi_cloud_up from './weather_icons/wi-cloud-up.svg'
import wi_moon_waxing_gibbous_6 from './weather_icons/wi-moon-waxing-gibbous-6.svg'
import wi_cloud from './weather_icons/wi-cloud.svg'
import wi_moonrise from './weather_icons/wi-moonrise.svg'
import wi_cloudy_gusts from './weather_icons/wi-cloudy-gusts.svg'
import wi_moonset from './weather_icons/wi-moonset.svg'
import wi_cloudy_windy from './weather_icons/wi-cloudy-windy.svg'
import wi_na from './weather_icons/wi-na.svg'
import wi_cloudy from './weather_icons/wi-cloudy.svg'
import wi_night_alt_cloudy_gusts from './weather_icons/wi-night-alt-cloudy-gusts.svg'
import wi_day_cloudy_gusts from './weather_icons/wi-day-cloudy-gusts.svg'
import wi_night_alt_cloudy_high from './weather_icons/wi-night-alt-cloudy-high.svg'
import wi_day_cloudy_high from './weather_icons/wi-day-cloudy-high.svg'
import wi_night_alt_cloudy_windy from './weather_icons/wi-night-alt-cloudy-windy.svg'
import wi_day_cloudy_windy from './weather_icons/wi-day-cloudy-windy.svg'
import wi_night_alt_cloudy from './weather_icons/wi-night-alt-cloudy.svg'
import wi_day_cloudy from './weather_icons/wi-day-cloudy.svg'
import wi_night_alt_hail from './weather_icons/wi-night-alt-hail.svg'
import wi_day_fog from './weather_icons/wi-day-fog.svg'
import wi_night_alt_lightning from './weather_icons/wi-night-alt-lightning.svg'
import wi_day_hail from './weather_icons/wi-day-hail.svg'
import wi_night_alt_partly_cloudy from './weather_icons/wi-night-alt-partly-cloudy.svg'
import wi_day_haze from './weather_icons/wi-day-haze.svg'
import wi_night_alt_rain_mix from './weather_icons/wi-night-alt-rain-mix.svg'
import wi_day_light_wind from './weather_icons/wi-day-light-wind.svg'
import wi_night_alt_rain_wind from './weather_icons/wi-night-alt-rain-wind.svg'
import wi_day_lightning from './weather_icons/wi-day-lightning.svg'
import wi_night_alt_rain from './weather_icons/wi-night-alt-rain.svg'
import wi_day_rain_mix from './weather_icons/wi-day-rain-mix.svg'
import wi_night_alt_showers from './weather_icons/wi-night-alt-showers.svg'
import wi_day_rain_wind from './weather_icons/wi-day-rain-wind.svg'
import wi_night_alt_sleet_storm from './weather_icons/wi-night-alt-sleet-storm.svg'
import wi_day_rain from './weather_icons/wi-day-rain.svg'
import wi_night_alt_sleet from './weather_icons/wi-night-alt-sleet.svg'
import wi_day_showers from './weather_icons/wi-day-showers.svg'
import wi_night_alt_snow_thunderstorm from './weather_icons/wi-night-alt-snow-thunderstorm.svg'
import wi_day_sleet_storm from './weather_icons/wi-day-sleet-storm.svg'
import wi_night_alt_snow_wind from './weather_icons/wi-night-alt-snow-wind.svg'
import wi_day_sleet from './weather_icons/wi-day-sleet.svg'
import wi_night_alt_snow from './weather_icons/wi-night-alt-snow.svg'
import wi_day_snow_thunderstorm from './weather_icons/wi-day-snow-thunderstorm.svg'
import wi_night_alt_sprinkle from './weather_icons/wi-night-alt-sprinkle.svg'
import wi_day_snow_wind from './weather_icons/wi-day-snow-wind.svg'
import wi_night_alt_storm_showers from './weather_icons/wi-night-alt-storm-showers.svg'
import wi_day_snow from './weather_icons/wi-day-snow.svg'
import wi_night_alt_thunderstorm from './weather_icons/wi-night-alt-thunderstorm.svg'
import wi_day_sprinkle from './weather_icons/wi-day-sprinkle.svg'
import wi_night_clear from './weather_icons/wi-night-clear.svg'
import wi_day_storm_showers from './weather_icons/wi-day-storm-showers.svg'
import wi_night_cloudy_gusts from './weather_icons/wi-night-cloudy-gusts.svg'
import wi_day_sunny_overcast from './weather_icons/wi-day-sunny-overcast.svg'
import wi_night_cloudy_high from './weather_icons/wi-night-cloudy-high.svg'
import wi_day_sunny from './weather_icons/wi-day-sunny.svg'
import wi_night_cloudy_windy from './weather_icons/wi-night-cloudy-windy.svg'
import wi_day_thunderstorm from './weather_icons/wi-day-thunderstorm.svg'
import wi_night_cloudy from './weather_icons/wi-night-cloudy.svg'
import wi_day_windy from './weather_icons/wi-day-windy.svg'
import wi_night_fog from './weather_icons/wi-night-fog.svg'
import wi_degrees from './weather_icons/wi-degrees.svg'
import wi_night_hail from './weather_icons/wi-night-hail.svg'
import wi_direction_down_left from './weather_icons/wi-direction-down-left.svg'
import wi_night_lightning from './weather_icons/wi-night-lightning.svg'
import wi_direction_down_right from './weather_icons/wi-direction-down-right.svg'
import wi_night_partly_cloudy from './weather_icons/wi-night-partly-cloudy.svg'
import wi_direction_down from './weather_icons/wi-direction-down.svg'
import wi_night_rain_mix from './weather_icons/wi-night-rain-mix.svg'
import wi_direction_left from './weather_icons/wi-direction-left.svg'
import wi_night_rain_wind from './weather_icons/wi-night-rain-wind.svg'
import wi_direction_right from './weather_icons/wi-direction-right.svg'
import wi_night_rain from './weather_icons/wi-night-rain.svg'
import wi_direction_up_left from './weather_icons/wi-direction-up-left.svg'
import wi_night_showers from './weather_icons/wi-night-showers.svg'
import wi_direction_up_right from './weather_icons/wi-direction-up-right.svg'
import wi_night_sleet_storm from './weather_icons/wi-night-sleet-storm.svg'
import wi_direction_up from './weather_icons/wi-direction-up.svg'
import wi_night_sleet from './weather_icons/wi-night-sleet.svg'
import wi_dust from './weather_icons/wi-dust.svg'
import wi_night_snow_thunderstorm from './weather_icons/wi-night-snow-thunderstorm.svg'
import wi_earthquake from './weather_icons/wi-earthquake.svg'
import wi_night_snow_wind from './weather_icons/wi-night-snow-wind.svg'
import wi_fahrenheit from './weather_icons/wi-fahrenheit.svg'
import wi_night_snow from './weather_icons/wi-night-snow.svg'
import wi_fire from './weather_icons/wi-fire.svg'
import wi_night_sprinkle from './weather_icons/wi-night-sprinkle.svg'
import wi_flood from './weather_icons/wi-flood.svg'
import wi_night_storm_showers from './weather_icons/wi-night-storm-showers.svg'
import wi_fog from './weather_icons/wi-fog.svg'
import wi_night_thunderstorm from './weather_icons/wi-night-thunderstorm.svg'
import wi_gale_warning from './weather_icons/wi-gale-warning.svg'
import wi_rain_mix from './weather_icons/wi-rain-mix.svg'
import wi_hail from './weather_icons/wi-hail.svg'
import wi_rain_wind from './weather_icons/wi-rain-wind.svg'
import wi_horizon_alt from './weather_icons/wi-horizon-alt.svg'
import wi_rain from './weather_icons/wi-rain.svg'
import wi_horizon from './weather_icons/wi-horizon.svg'
import wi_raindrop from './weather_icons/wi-raindrop.svg'
import wi_hot from './weather_icons/wi-hot.svg'
import wi_raindrops from './weather_icons/wi-raindrops.svg'
import wi_humidity from './weather_icons/wi-humidity.svg'
import wi_refresh_alt from './weather_icons/wi-refresh-alt.svg'
import wi_hurricane_warning from './weather_icons/wi-hurricane-warning.svg'
import wi_refresh from './weather_icons/wi-refresh.svg'
import wi_hurricane from './weather_icons/wi-hurricane.svg'
import wi_sandstorm from './weather_icons/wi-sandstorm.svg'
import wi_lightning from './weather_icons/wi-lightning.svg'
import wi_showers from './weather_icons/wi-showers.svg'
import wi_lunar_eclipse from './weather_icons/wi-lunar-eclipse.svg'
import wi_sleet from './weather_icons/wi-sleet.svg'
import wi_meteor from './weather_icons/wi-meteor.svg'
import wi_small_craft_advisory from './weather_icons/wi-small-craft-advisory.svg'
import wi_moon_alt_first_quarter from './weather_icons/wi-moon-alt-first-quarter.svg'
import wi_smog from './weather_icons/wi-smog.svg'
import wi_moon_alt_full from './weather_icons/wi-moon-alt-full.svg'
import wi_smoke from './weather_icons/wi-smoke.svg'
import wi_moon_alt_new from './weather_icons/wi-moon-alt-new.svg'
import wi_snow_wind from './weather_icons/wi-snow-wind.svg'
import wi_moon_alt_third_quarter from './weather_icons/wi-moon-alt-third-quarter.svg'
import wi_snow from './weather_icons/wi-snow.svg'
import wi_moon_alt_waning_crescent_1 from './weather_icons/wi-moon-alt-waning-crescent-1.svg'
import wi_snowflake_cold from './weather_icons/wi-snowflake-cold.svg'
import wi_moon_alt_waning_crescent_2 from './weather_icons/wi-moon-alt-waning-crescent-2.svg'
import wi_solar_eclipse from './weather_icons/wi-solar-eclipse.svg'
import wi_moon_alt_waning_crescent_3 from './weather_icons/wi-moon-alt-waning-crescent-3.svg'
import wi_sprinkle from './weather_icons/wi-sprinkle.svg'
import wi_moon_alt_waning_crescent_4 from './weather_icons/wi-moon-alt-waning-crescent-4.svg'
import wi_stars from './weather_icons/wi-stars.svg'
import wi_moon_alt_waning_crescent_5 from './weather_icons/wi-moon-alt-waning-crescent-5.svg'
import wi_storm_showers from './weather_icons/wi-storm-showers.svg'
import wi_moon_alt_waning_crescent_6 from './weather_icons/wi-moon-alt-waning-crescent-6.svg'
import wi_storm_warning from './weather_icons/wi-storm-warning.svg'
import wi_moon_alt_waning_gibbous_1 from './weather_icons/wi-moon-alt-waning-gibbous-1.svg'
import wi_strong_wind from './weather_icons/wi-strong-wind.svg'
import wi_moon_alt_waning_gibbous_2 from './weather_icons/wi-moon-alt-waning-gibbous-2.svg'
import wi_sunrise from './weather_icons/wi-sunrise.svg'
import wi_moon_alt_waning_gibbous_3 from './weather_icons/wi-moon-alt-waning-gibbous-3.svg'
import wi_sunset from './weather_icons/wi-sunset.svg'
import wi_moon_alt_waning_gibbous_4 from './weather_icons/wi-moon-alt-waning-gibbous-4.svg'
import wi_thermometer_exterior from './weather_icons/wi-thermometer-exterior.svg'
import wi_moon_alt_waning_gibbous_5 from './weather_icons/wi-moon-alt-waning-gibbous-5.svg'
import wi_thermometer_internal from './weather_icons/wi-thermometer-internal.svg'
import wi_moon_alt_waning_gibbous_6 from './weather_icons/wi-moon-alt-waning-gibbous-6.svg'
import wi_thermometer from './weather_icons/wi-thermometer.svg'
import wi_moon_alt_waxing_crescent_1 from './weather_icons/wi-moon-alt-waxing-crescent-1.svg'
import wi_thunderstorm from './weather_icons/wi-thunderstorm.svg'
import wi_moon_alt_waxing_crescent_2 from './weather_icons/wi-moon-alt-waxing-crescent-2.svg'
import wi_time_1 from './weather_icons/wi-time-1.svg'
import wi_moon_alt_waxing_crescent_3 from './weather_icons/wi-moon-alt-waxing-crescent-3.svg'
import wi_time_10 from './weather_icons/wi-time-10.svg'
import wi_moon_alt_waxing_crescent_4 from './weather_icons/wi-moon-alt-waxing-crescent-4.svg'
import wi_time_11 from './weather_icons/wi-time-11.svg'
import wi_moon_alt_waxing_crescent_5 from './weather_icons/wi-moon-alt-waxing-crescent-5.svg'
import wi_time_12 from './weather_icons/wi-time-12.svg'
import wi_moon_alt_waxing_crescent_6 from './weather_icons/wi-moon-alt-waxing-crescent-6.svg'
import wi_time_2 from './weather_icons/wi-time-2.svg'
import wi_moon_alt_waxing_gibbous_1 from './weather_icons/wi-moon-alt-waxing-gibbous-1.svg'
import wi_time_3 from './weather_icons/wi-time-3.svg'
import wi_moon_alt_waxing_gibbous_2 from './weather_icons/wi-moon-alt-waxing-gibbous-2.svg'
import wi_time_4 from './weather_icons/wi-time-4.svg'
import wi_moon_alt_waxing_gibbous_3 from './weather_icons/wi-moon-alt-waxing-gibbous-3.svg'
import wi_time_5 from './weather_icons/wi-time-5.svg'
import wi_moon_alt_waxing_gibbous_4 from './weather_icons/wi-moon-alt-waxing-gibbous-4.svg'
import wi_time_6 from './weather_icons/wi-time-6.svg'
import wi_moon_alt_waxing_gibbous_5 from './weather_icons/wi-moon-alt-waxing-gibbous-5.svg'
import wi_time_7 from './weather_icons/wi-time-7.svg'
import wi_moon_alt_waxing_gibbous_6 from './weather_icons/wi-moon-alt-waxing-gibbous-6.svg'
import wi_time_8 from './weather_icons/wi-time-8.svg'
import wi_moon_first_quarter from './weather_icons/wi-moon-first-quarter.svg'
import wi_time_9 from './weather_icons/wi-time-9.svg'
import wi_moon_full from './weather_icons/wi-moon-full.svg'
import wi_tornado from './weather_icons/wi-tornado.svg'
import wi_moon_new from './weather_icons/wi-moon-new.svg'
import wi_train from './weather_icons/wi-train.svg'
import wi_moon_third_quarter from './weather_icons/wi-moon-third-quarter.svg'
import wi_tsunami from './weather_icons/wi-tsunami.svg'
import wi_moon_waning_crescent_1 from './weather_icons/wi-moon-waning-crescent-1.svg'
import wi_umbrella from './weather_icons/wi-umbrella.svg'
import wi_moon_waning_crescent_2 from './weather_icons/wi-moon-waning-crescent-2.svg'
import wi_volcano from './weather_icons/wi-volcano.svg'
import wi_moon_waning_crescent_3 from './weather_icons/wi-moon-waning-crescent-3.svg'
import wi_wind_beaufort_0 from './weather_icons/wi-wind-beaufort-0.svg'
import wi_moon_waning_crescent_4 from './weather_icons/wi-moon-waning-crescent-4.svg'
import wi_wind_beaufort_1 from './weather_icons/wi-wind-beaufort-1.svg'
import wi_moon_waning_crescent_5 from './weather_icons/wi-moon-waning-crescent-5.svg'
import wi_wind_beaufort_10 from './weather_icons/wi-wind-beaufort-10.svg'
import wi_moon_waning_crescent_6 from './weather_icons/wi-moon-waning-crescent-6.svg'
import wi_wind_beaufort_11 from './weather_icons/wi-wind-beaufort-11.svg'
import wi_moon_waning_gibbous_1 from './weather_icons/wi-moon-waning-gibbous-1.svg'
import wi_wind_beaufort_12 from './weather_icons/wi-wind-beaufort-12.svg'
import wi_moon_waning_gibbous_2 from './weather_icons/wi-moon-waning-gibbous-2.svg'
import wi_wind_beaufort_2 from './weather_icons/wi-wind-beaufort-2.svg'
import wi_moon_waning_gibbous_3 from './weather_icons/wi-moon-waning-gibbous-3.svg'
import wi_wind_beaufort_3 from './weather_icons/wi-wind-beaufort-3.svg'
import wi_moon_waning_gibbous_4 from './weather_icons/wi-moon-waning-gibbous-4.svg'
import wi_wind_beaufort_4 from './weather_icons/wi-wind-beaufort-4.svg'
import wi_moon_waning_gibbous_5 from './weather_icons/wi-moon-waning-gibbous-5.svg'
import wi_wind_beaufort_5 from './weather_icons/wi-wind-beaufort-5.svg'
import wi_moon_waning_gibbous_6 from './weather_icons/wi-moon-waning-gibbous-6.svg'
import wi_wind_beaufort_6 from './weather_icons/wi-wind-beaufort-6.svg'
import wi_moon_waxing_6 from './weather_icons/wi-moon-waxing-6.svg'
import wi_wind_beaufort_7 from './weather_icons/wi-wind-beaufort-7.svg'
import wi_moon_waxing_crescent_1 from './weather_icons/wi-moon-waxing-crescent-1.svg'
import wi_wind_beaufort_8 from './weather_icons/wi-wind-beaufort-8.svg'
import wi_moon_waxing_crescent_2 from './weather_icons/wi-moon-waxing-crescent-2.svg'
import wi_wind_beaufort_9 from './weather_icons/wi-wind-beaufort-9.svg'
import wi_moon_waxing_crescent_3 from './weather_icons/wi-moon-waxing-crescent-3.svg'
import wi_wind_deg from './weather_icons/wi-wind-deg.svg'
  

const weatherIcons = {
wi_alien,
wi_moon_waxing_gibbous_1,
wi_barometer,
wi_moon_waxing_gibbous_2,
wi_celsius,
wi_moon_waxing_gibbous_3,
wi_cloud_down,
wi_moon_waxing_gibbous_4,
wi_cloud_refresh,
wi_moon_waxing_gibbous_5,
wi_cloud_up,
wi_moon_waxing_gibbous_6,
wi_cloud,
wi_moonrise,
wi_cloudy_gusts,
wi_moonset,
wi_cloudy_windy,
wi_na,
wi_cloudy,
wi_night_alt_cloudy_gusts,
wi_day_cloudy_gusts,
wi_night_alt_cloudy_high,
wi_day_cloudy_high,
wi_night_alt_cloudy_windy,
wi_day_cloudy_windy,
wi_night_alt_cloudy,
wi_day_cloudy,
wi_night_alt_hail,
wi_day_fog,
wi_night_alt_lightning,
wi_day_hail,
wi_night_alt_partly_cloudy,
wi_day_haze,
wi_night_alt_rain_mix,
wi_day_light_wind,
wi_night_alt_rain_wind,
wi_day_lightning,
wi_night_alt_rain,
wi_day_rain_mix,
wi_night_alt_showers,
wi_day_rain_wind,
wi_night_alt_sleet_storm,
wi_day_rain,
wi_night_alt_sleet,
wi_day_showers,
wi_night_alt_snow_thunderstorm,
wi_day_sleet_storm,
wi_night_alt_snow_wind,
wi_day_sleet,
wi_night_alt_snow,
wi_day_snow_thunderstorm,
wi_night_alt_sprinkle,
wi_day_snow_wind,
wi_night_alt_storm_showers,
wi_day_snow,
wi_night_alt_thunderstorm,
wi_day_sprinkle,
wi_night_clear,
wi_day_storm_showers,
wi_night_cloudy_gusts,
wi_day_sunny_overcast,
wi_night_cloudy_high,
wi_day_sunny,
wi_night_cloudy_windy,
wi_day_thunderstorm,
wi_night_cloudy,
wi_day_windy,
wi_night_fog,
wi_degrees,
wi_night_hail,
wi_direction_down_left,
wi_night_lightning,
wi_direction_down_right,
wi_night_partly_cloudy,
wi_direction_down,
wi_night_rain_mix,
wi_direction_left,
wi_night_rain_wind,
wi_direction_right,
wi_night_rain,
wi_direction_up_left,
wi_night_showers,
wi_direction_up_right,
wi_night_sleet_storm,
wi_direction_up,
wi_night_sleet,
wi_dust,
wi_night_snow_thunderstorm,
wi_earthquake,
wi_night_snow_wind,
wi_fahrenheit,
wi_night_snow,
wi_fire,
wi_night_sprinkle,
wi_flood,
wi_night_storm_showers,
wi_fog,
wi_night_thunderstorm,
wi_gale_warning,
wi_rain_mix,
wi_hail,
wi_rain_wind,
wi_horizon_alt,
wi_rain,
wi_horizon,
wi_raindrop,
wi_hot,
wi_raindrops,
wi_humidity,
wi_refresh_alt,
wi_hurricane_warning,
wi_refresh,
wi_hurricane,
wi_sandstorm,
wi_lightning,
wi_showers,
wi_lunar_eclipse,
wi_sleet,
wi_meteor,
wi_small_craft_advisory,
wi_moon_alt_first_quarter,
wi_smog,
wi_moon_alt_full,
wi_smoke,
wi_moon_alt_new,
wi_snow_wind,
wi_moon_alt_third_quarter,
wi_snow,
wi_moon_alt_waning_crescent_1,
wi_snowflake_cold,
wi_moon_alt_waning_crescent_2,
wi_solar_eclipse,
wi_moon_alt_waning_crescent_3,
wi_sprinkle,
wi_moon_alt_waning_crescent_4,
wi_stars,
wi_moon_alt_waning_crescent_5,
wi_storm_showers,
wi_moon_alt_waning_crescent_6,
wi_storm_warning,
wi_moon_alt_waning_gibbous_1,
wi_strong_wind,
wi_moon_alt_waning_gibbous_2,
wi_sunrise,
wi_moon_alt_waning_gibbous_3,
wi_sunset,
wi_moon_alt_waning_gibbous_4,
wi_thermometer_exterior,
wi_moon_alt_waning_gibbous_5,
wi_thermometer_internal,
wi_moon_alt_waning_gibbous_6,
wi_thermometer,
wi_moon_alt_waxing_crescent_1,
wi_thunderstorm,
wi_moon_alt_waxing_crescent_2,
wi_time_1,
wi_moon_alt_waxing_crescent_3,
wi_time_10,
wi_moon_alt_waxing_crescent_4,
wi_time_11,
wi_moon_alt_waxing_crescent_5,
wi_time_12,
wi_moon_alt_waxing_crescent_6,
wi_time_2,
wi_moon_alt_waxing_gibbous_1,
wi_time_3,
wi_moon_alt_waxing_gibbous_2,
wi_time_4,
wi_moon_alt_waxing_gibbous_3,
wi_time_5,
wi_moon_alt_waxing_gibbous_4,
wi_time_6,
wi_moon_alt_waxing_gibbous_5,
wi_time_7,
wi_moon_alt_waxing_gibbous_6,
wi_time_8,
wi_moon_first_quarter,
wi_time_9,
wi_moon_full,
wi_tornado,
wi_moon_new,
wi_train,
wi_moon_third_quarter,
wi_tsunami,
wi_moon_waning_crescent_1,
wi_umbrella,
wi_moon_waning_crescent_2,
wi_volcano,
wi_moon_waning_crescent_3,
wi_wind_beaufort_0,
wi_moon_waning_crescent_4,
wi_wind_beaufort_1,
wi_moon_waning_crescent_5,
wi_wind_beaufort_10,
wi_moon_waning_crescent_6,
wi_wind_beaufort_11,
wi_moon_waning_gibbous_1,
wi_wind_beaufort_12,
wi_moon_waning_gibbous_2,
wi_wind_beaufort_2,
wi_moon_waning_gibbous_3,
wi_wind_beaufort_3,
wi_moon_waning_gibbous_4,
wi_wind_beaufort_4,
wi_moon_waning_gibbous_5,
wi_wind_beaufort_5,
wi_moon_waning_gibbous_6,
wi_wind_beaufort_6,
wi_moon_waxing_6,
wi_wind_beaufort_7,
wi_moon_waxing_crescent_1,
wi_wind_beaufort_8,
wi_moon_waxing_crescent_2,
wi_wind_beaufort_9,
wi_moon_waxing_crescent_3,
wi_wind_deg
}

export default weatherIcons 